// const BASE_URL = "https://localhost:7231/api/Login";
// const BASE_URL = "https://patmitracbs.in/api/Login";
// const response = await fetch("https://patmitracbs.in/api/Login",


import { BASE_URL } from "../config";

export const LoginApi = async (loginData) => {
  try {
    const response = await fetch(`${BASE_URL}/Login`,
       {
          method: "POST",
         headers: { "Content-Type": "application/json"
      },
      body: JSON.stringify(loginData)
    });

    const result = await response.json(); 
    if (!response.ok) {
      throw new Error(result.message || "Failed to Login");
    }

    // return await response.json(); 
    // const result = await response.text();
    console.log("Success:", result);
    return result;

  } catch (error) {
    console.error("Error Login:", error);
    throw error;
  }
};